import { render, staticRenderFns } from "./first-rank.vue?vue&type=template&id=01a8e2f6&scoped=true&"
import script from "./first-rank.vue?vue&type=script&lang=js&"
export * from "./first-rank.vue?vue&type=script&lang=js&"
import style0 from "./first-rank.vue?vue&type=style&index=0&id=01a8e2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8e2f6",
  null
  
)

export default component.exports